import { Button, Card, Col, Form, Input, Row } from "antd";
import { getEntidadePorCnpj, getEntidadePorMatricula } from "../services/apiCad";
import { onlyNumbers } from "../utils/utilsFunctions";
import { useState } from "react";
import { getEntidadesAtivas } from "../auth/entidadeUsuario";
import { apiAuxiliar } from "../services/apiAuxiliar";
import { errorMessage, successMessage } from "../utils/messages";


const Debug = () => {
  const [form] = Form.useForm();
  const [printado, setPrintado] = useState<string>('');


  return (
  <Card title='Depurar Entidades do CAD'>
    <Form layout='vertical' form={form}>
      <Row>
        <Col>
          <Form.Item label='Matrícula' name='matricula'>
            <Input/>
          </Form.Item>
        </Col>
        <Col>
          <br/>
          <Button
            shape='round'
            onClick={async() => {
                const matricula = onlyNumbers(form.getFieldValue("matricula"));
                const entidade = await getEntidadePorMatricula(matricula);
                setPrintado(JSON.stringify(entidade));
            }}
          >Buscar</Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form.Item label='CNPJ' name='cnpj'>
            <Input/>
          </Form.Item>
        </Col>
        <Col>
          <br/>
          <Button
            shape='round'
            onClick={async() => {
                const cnpj = onlyNumbers(form.getFieldValue("cnpj"));
                const entidade = await getEntidadePorCnpj(cnpj);
                setPrintado(JSON.stringify(entidade));
            }}
          >Buscar</Button>
        </Col>
      </Row>
      <Row>
        <Col>
            <Button
                shape='round'
                onClick={() => {
                    const entidades = getEntidadesAtivas();
                    setPrintado(JSON.stringify(entidades));
                }}
            >Lista</Button>
        </Col>
      </Row>
      <Row>
        <Col><br/></Col>
      </Row>
      <Row>
        <Col>
            <Button
                shape='round'
                onClick={async() => {
                    await apiAuxiliar.delete("/auxiliar/limpar-cache").then((response) => {
                        successMessage("Cache atualizado.");
                    }).catch(err => {
                        errorMessage(`Erro: ${err}`);
                    });
                }}
            >Atualizar cache</Button>
        </Col>
      </Row>
    </Form>
    <div>{printado}</div>
  </Card>
  );
};

export default Debug;
